import { render, staticRenderFns } from "./GiftAnimation.vue?vue&type=template&id=66f6ced6&scoped=true&"
import script from "./GiftAnimation.vue?vue&type=script&lang=ts&"
export * from "./GiftAnimation.vue?vue&type=script&lang=ts&"
import style0 from "./GiftAnimation.vue?vue&type=style&index=0&id=66f6ced6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66f6ced6",
  null
  
)

export default component.exports